module.exports = __webpack_public_path__ + "static/media/isotype_gransfer.60999523.svg";